module.exports = __webpack_public_path__ + "static/icon-misc-22cc9d2ce96b4eca9d83ed11c4fe5a33.svg";